// React imports.
import React, { Component } from "react";
//library imports
import Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting'; 
import offlineExporting from 'highcharts/modules/offline-exporting';
import HighchartsReact from 'highcharts-react-official';

import { IHighChartsDataseries, formatLabelNumber } from "../utility";

exporting(Highcharts);
offlineExporting(Highcharts);


const ChartStackedBarPercent = ({title, subTitle, dataSeries, xAxisCategoryLabels, formatFunction}) => {

  let toolTipParamObject = function () {
    return '<b>' + this.key + '</b><br/><span style="color:'
      + this.series.color + '">' + this.series.name + '</span>:<br/> '
      + this.point.displayVal + '<br/>'
      + this.point.percentage.toFixed(1) + ' %<br/>'
      ;
  };


  const yAxisObjectArray = [{
        labels: {
          formatter: formatFunction,
          style: {
            //color: Highcharts.getOptions().colors[0]
            color: '#000'
          }
        },
        gridLineColor: '#555',
        title: {
          text: ' ',
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        min: 0
      }];


  let options = {
    exporting: {
      buttons: {
          contextButton: {
              menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG']
          }
      }
    },
    credits: {
      enabled: false
    },
    chart: {
      height: 600,
      type: 'column',
    },
    title: {
      text: title
    },
    legend: { layout: 'vertical' },
    subtitl: {
      text: subTitle
    },
    xAxis: {
      labels: {
        enabled: true,
      },
      categories: xAxisCategoryLabels,
      crosshair: true
    },
    yAxis: yAxisObjectArray,
    series: dataSeries,
    tooltip: {
        formatter: toolTipParamObject,
        shared: false
    },
    plotOptions: {
      series:
      {
        dataLabels: {
          enabled: false,
          formatter: function () {
            return formatLabelNumber(this.y, true, this.point.prefix, this.point.suffix);
          },
          style: {
            textShadow: ''
          }
        }
      },
      column: {
        stacking: 'percent',
        pointPadding: 0.2,
        borderWidth: 0
      }
    }
 
  };
  return (
    <HighchartsReact highcharts={Highcharts} options={options} />
  );
}
export default ChartStackedBarPercent;
